<template>
  <div
    class="flex flex-col items-start page-wrapper md:flex-row h-full p-0 flex-grow"
  >
    <section
      class="w-full h-full"
      :class="{
        'bg-surface-primary rounded-md p-24 lg:p-24 md:px-93 md:py-24':
          familyStore.ui.isProductPage === false,
      }"
    >
      <header>
        <h2 v-if="!familyStore.ui.isProductPage" class="heading-xs pb-16">
          Lägg till
        </h2>
        <h3 class="heading-xxs pb-16">Jag är befintlig kund</h3>
        <p class="pb-16">
          Jag har redan ett 20 GB abonnemang eller högre som jag vill koppla ett
          familjeabonnemang till.
        </p>
      </header>
      <FamilyDiscountLabels :existing-customer="true" :in-drawer="false" />
      <div class="pb-32 border-b-2 border-solid border-border-secondary">
        <div class="flex flex-col justify-center gap-10">
          <AppButton
            :full-width="true"
            aria-label="Lägg till familjeanslutning som befintlig kund, med BankID"
            @on-click="
              () => {
                familyStore.addExistingCustomer();
              }
            "
          >
            <div class="text-[18px] md:text-24-26">
              Lägg till familjeanslutning
            </div>
            <nuxt-icon name="bankId" aria-label="bankid ikon" />
          </AppButton>
          <AppButton
            v-if="isTestEnvironment()"
            :full-width="true"
            @on-click="
              () => {
                familyStore.bankIdTestPassthrough();
              }
            "
          >
            <div class="text-[18px] md:text-24-26">
              TEST Lägg till familjeanslutning
            </div>
          </AppButton>
          <AppButton
            v-if="!familyStore.ui.isProductPage"
            class="mt-5"
            color="secondary"
            :full-width="true"
            href="/mobiltelefoner"
          >
            <div class="text-[18px] md:text-24-26">Abonnemang och mobil</div>
            <nuxt-icon name="arrow-right" aria-hidden="true" />
          </AppButton>
        </div>
      </div>
      <div class="flex flex-col items-left pt-32">
        <h3 class="heading-xxs pb-16">Jag är ny kund</h3>
        <p class="pb-16">Jag har inget Halebop abonnemang sedan tidigare.</p>
        <FamilyDiscountLabels :existing-customer="false" :in-drawer="false" />
      </div>
      <div>
        <div class="flex flex-col justify-center gap-10">
          <AppButton
            :full-width="true"
            aria-label="Lägg till familjeanslutning som ny kund"
            @on-click="
              () => {
                familyStore.addNewCustomer();
              }
            "
          >
            <div class="text-[18px] md:text-24-26">
              {{ currentCustomerBtnText }}
            </div>
          </AppButton>
          <AppButton
            v-if="!familyStore.ui.isProductPage"
            class="mt-5"
            color="secondary"
            :full-width="true"
            href="/mobiltelefoner"
          >
            <div class="text-[18px] md:text-24-26">Abonnemang och mobil</div>
            <nuxt-icon name="arrow-right" aria-hidden="true" />
          </AppButton>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { isTestEnvironment } from '~/utils/general/isTestEnvironment';

const familyStore = useFamilyStore();

interface Props {
  currentCustomerBtnText: string;
}
defineProps<Props>();
</script>

<style scoped></style>
